<svg height="21" viewBox="0 0 21 21" width="21" xmlns="http://www.w3.org/2000/svg">
  <path d="m.5 8.5 4-4-4-4" fill="none" stroke="currentColor" stroke-width='2' stroke-linecap="round" stroke-linejoin="round" transform="translate(9 6)"/>
</svg>
